import { Dispatch, SetStateAction, useState, useEffect } from 'react';
import { useWeb3Modal } from '@web3modal/wagmi/react';
import { useSignMessage, useAccount } from 'wagmi';

import { SidebarModal } from '../../../components';

import { Step1 } from './Step1';
import { Step2 } from './Step2';
import { Step3 } from './Step3';
import { Step4 } from './Step4';
import { Step5 } from './Step5';
import { Step6 } from './Step6';
import { Step7 } from './Step7';
import { Step8 } from './Step8';
import { Step9 } from './Step9';
import { WithdrawStepsEnum } from './types';
import { useAppSelector } from '../../../app/hooks';
import { useDisconnect } from 'wagmi';

interface WithdrawHubsProps {
  openModal: boolean;
  setOpenModal: Dispatch<SetStateAction<boolean>>;
  packageId: number;
  withdrawStep: WithdrawStepsEnum;
  setWithdrawStep: Dispatch<SetStateAction<WithdrawStepsEnum>>;
}

export const WithdrawHubs = ({
  openModal,
  setOpenModal,
  packageId,
  withdrawStep,
  setWithdrawStep
}: WithdrawHubsProps) => {
  const [walletAddress, setWalletAddress] = useState<string | undefined>('');
  const [walletAddressSign, setWalletAddressSign] = useState('');

  const [code, setCode] = useState('');
  const [code2Fa, setCode2Fa] = useState('');

  const { disconnect } = useDisconnect();
  const { user } = useAppSelector((state) => state.auth.userInfo);

  const { address, isConnected, connector } = useAccount();

  const { open } = useWeb3Modal();

  const { signMessageAsync } = useSignMessage();

  const message = JSON.stringify({
    user_id: user.id,
    order_id: packageId,
    to: address
  });

  const parsedMessage = JSON.parse(message);

  useEffect(() => {
    if (isConnected) {
      setWalletAddress(address);
    }

    if (parsedMessage.order_id !== 1 && walletAddressSign === '') {
      (async () => {
        if (isConnected) {
          const signature = await signMessageAsync({ connector, message });

          setWalletAddressSign(signature);
        }
      })();
    }
  }, [isConnected]);

  const withdrawSteps = (step: WithdrawStepsEnum) => {
    switch (step) {
      case WithdrawStepsEnum.INIT:
        return (
          <Step1
            setWithdrawStep={setWithdrawStep}
            setOpenModal={setOpenModal}
          />
        );

      case WithdrawStepsEnum.CONNECT_WALLET:
        return (
          <Step2
            setWithdrawStep={setWithdrawStep}
            walletAddress={walletAddress}
            walletAddressSign={walletAddressSign}
            connectWallet={open}
            isConnected={isConnected}
            setWalletAddressSign={setWalletAddressSign}
          />
        );

      case WithdrawStepsEnum.SECURITY_VERIFICATION:
        return (
          <Step3
            setWithdrawStep={setWithdrawStep}
            setWalletAddress={setWalletAddress}
            walletAddress={walletAddress}
            walletAddressSign={walletAddressSign}
            packageId={packageId}
            code={code}
            code2Fa={code2Fa}
            setCode={setCode}
            setCode2Fa={setCode2Fa}
          />
        );

      case WithdrawStepsEnum.TWO_FA_FACTOR_REQUIRED:
        return <Step4 />;

      case WithdrawStepsEnum.FINAL_STEP:
        return (
          <Step5
            setWithdrawStep={setWithdrawStep}
            walletAddress={walletAddress}
            packageId={packageId}
            walletAddressSign={walletAddressSign}
            code={code}
            code2Fa={code2Fa}
            isConnected={isConnected}
            connectWallet={open}
            setWalletAddressSign={setWalletAddressSign}
          />
        );

      case WithdrawStepsEnum.APPROVE_TRANSACTION:
        return (
          <Step6
            setWithdrawStep={setWithdrawStep}
            setWalletAddress={setWalletAddress}
          />
        );

      case WithdrawStepsEnum.APPROVE_TRANSACTION_SUCCESS:
        return <Step7 />;

      case WithdrawStepsEnum.APPROVE_TRANSACTION_FAIL:
        return <Step8 />;

      case WithdrawStepsEnum.NO_KYC:
        return <Step9 />;
      default:
        break;
    }
  };

  return (
    <div>
      <SidebarModal
        isOpen={openModal}
        setOpen={(v) => {
          setOpenModal(!openModal);
          setWithdrawStep(WithdrawStepsEnum.INIT);

          disconnect();

          if (withdrawStep === WithdrawStepsEnum.APPROVE_TRANSACTION_SUCCESS) {
            window.location.reload();
          }
        }}
        title='Withdrawing your NFT'
        sidebarWidth={'560px'}>
        {withdrawSteps(withdrawStep)}{' '}
      </SidebarModal>
    </div>
  );
};
